<template>
  <v-row class="pa-0" dense>
    <v-col>
      <v-row class="mb-4" dense>
        <TitleCard :title="$vuetify.lang.t('$vuetify.transactionDetails')" icon="info_outline"/>
      </v-row>
      <v-row dense>
        <v-col class="pl-md-10">
          <v-row dense class="pb-2">
            <v-col cols="12" md="4">
              <DetailCard 
                test-id="transaction-detail-card"
                :icon="transactionStatus.icon" 
                :icon-color="transactionStatus.color"
                :title="$vuetify.lang.t('$vuetify.transactionState')">
                <template v-slot:content>
                  <span>
                    <span :style="'color:' + transactionStatus.color" style="font-weight: bolder">{{
                      transactionStatus.text }}</span>:
                    <span style="color: var(--tertiary)">{{capitalize(transaction_content?.state)}}</span>
                  </span>
                </template>
              </DetailCard>
            </v-col>
            <v-col cols="12" md="4">
              <DetailCard 
                test-id="transaction-creation-detail-card"
                :extra="transaction_content?.username" 
                :subtitle="`${dayjs.unix(transaction_content?.creation_timestamp).format(const_global.DATE_TIME_FORMAT_A)}  (${dayjs.unix(transaction_content?.creation_timestamp).fromNow()})`"
                :title="$vuetify.lang.t('$vuetify.creation')" />
            </v-col>
            <v-col cols="12" md="4">
              <DetailCard 
              test-id="transaction-last-event-detail-card"
              :extra="transaction_content?.last_event ? capitalize(transaction_content?.last_event) : '-'"
              :subtitle="transaction_content?.last_event_ts ? `${dayjs.unix(transaction_content?.last_event_ts).format(const_global.DATE_TIME_FORMAT_A)}  (${dayjs.unix(transaction_content?.last_event_ts).fromNow()})` : 'Sin datos'"
              :title="$vuetify.lang.t('$vuetify.transactionLastEvent')" 
              />
            </v-col>
          </v-row>
          <v-row v-if="transactionStatus.id === 'invalid'" class="pl-md-12 my-2" dense>
            <v-alert test-id="transaction-invalid-alert" class="cts-font-size-3" color="var(--primary)" dense icon="mdi-information-variant" outlined>
              {{ $vuetify.lang.t('$vuetify.transactionInvalidAlert') }}
            </v-alert>
          </v-row>
          <TransactionSectionDigitalSignature 
            class="mb-2" 
            test-id="transaction-digital-content"
            v-if="transactionModel === 'digital_signature'"
            :transaction_content="transaction_content" 
          />
          <v-row v-else-if="filteredTransactionParameters && filteredTransactionParameters.length !== 0" class="mb-2" dense>
            <v-col class="pa-0">
            <v-divider class="my-4" />
              <v-row class="my-2" dense>
                <v-col>
                  <span class="text-uppercase cts-color-tertiary" test-id="transaction-entry-data">
                    {{ $vuetify.lang.t('$vuetify.transactionEntryData') }}
                  </span>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col class="pa-0">
                  <TransactionEntryDataCard 
                  :transactionModel="transactionModel"
                  :transaction_recipient_data="transaction_recipient_data"
                  :transaction_content="transaction_content"
                  :filteredTransactionParameters="filteredTransactionParameters" />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import const_global from "@/constants/global";
import const_icons from "@/constants/icons";
import DetailCard from "@/components/sections/transactions/components/DetailCard.vue";
import TitleCard from "@/components/sections/transactions/components/TitleCard.vue";
import TransactionEntryDataCard from "@/components/sections/transactions/components/TransactionEntryDataCard.vue";
import TransactionSectionDigitalSignature from "@/components/sections/transactions/transactionsView/models/TransactionSectionDigitalSignature.vue";
export default {
  name: "TransactionDetailSummarySection",
  components: {
    TitleCard,
    DetailCard,
    TransactionEntryDataCard,
    TransactionSectionDigitalSignature,
  },
  data() {
    return {
      const_global,
      const_icons,
    };
  },
  props: {
    transactionStatus: Object,
    transaction_content: Object,
    dayjs: Function,
    capitalize: Function,
    transactionModel: String,
    filteredTransactionParameters: Array,
    transaction_recipient_data: Object,
  },


};

</script>